import { render, staticRenderFns } from "./israGud.vue?vue&type=template&id=dfb163aa&scoped=true&"
import script from "./israGud.vue?vue&type=script&lang=js&"
export * from "./israGud.vue?vue&type=script&lang=js&"
import style0 from "./israGud.vue?vue&type=style&index=0&id=dfb163aa&prod&scoped=true&lang=css&"
import style1 from "./israGud.vue?vue&type=style&index=1&id=dfb163aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb163aa",
  null
  
)

export default component.exports